// Countdown timer  23 hours from page load
  function startTimer() {
    const stored = sessionStorage.getItem('keto_timer_end');
    let endTime;
    if (stored) {
      endTime = parseInt(stored);
    } else {
      endTime = Date.now() + (23 * 60 * 60 * 1000);
      sessionStorage.setItem('keto_timer_end', endTime);
    }

    function update() {
      const now = Date.now();
      const diff = Math.max(0, endTime - now);
      const h = Math.floor(diff / 3600000).toString().padStart(2,'0');
      const m = Math.floor((diff % 3600000) / 60000).toString().padStart(2,'0');
      const s = Math.floor((diff % 60000) / 1000).toString().padStart(2,'0');
      const str = h + ':' + m + ':' + s;
      const t1 = document.getElementById('heroTimer');
      const t2 = document.getElementById('ctaTimer');
      if (t1) t1.textContent = str;
      if (t2) t2.textContent = str;
      if (diff > 0) setTimeout(update, 1000);
    }
    update();
  }
  startTimer();

  // Sticky bar
  const sticky = document.getElementById('stickyBar');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 500) sticky.classList.add('visible');
    else sticky.classList.remove('visible');
  });

  // FAQ
  function toggleFaq(btn) {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  }